export const environment = {
  envName: 'qastg',
  production: true,
  tagManagerEnv: 'env-3',
  tagManagerAuth: '-_rR6Zjc4bAOeaGltsAgvA',
  apiUrl: 'https://mcgrawhillebookqastg.mheducation.com/api',
  enablePendo: true,
  nrBrowser: {
    enabled: false,
    options: {
      info: {
        applicationID: 1834915278,
        beacon: 'bam.nr-data.net',
        errorBeacon: 'bam.nr-data.net',
        licenseKey: 'NRBR-33950553321f9090b38',
        sa: 1,
      },
      init: {
        ajax: {
          deny_list: ['bam.nr-data.net'],
        },
        distributed_tracing: {
          allowed_origins: [],
          cors_enabled: false,
          cors_use_newrelic_header: false,
          cors_use_tracecontext_headers: false,
          enabled: true,
          exclude_newrelic_header: false,
        },
        privacy: {
          cookies_enabled: true,
        },
        session_replay: {
          autoStart: true,
          block_selector: '',
          collect_fonts: true,
          enabled: true,
          error_sampling_rate: 100,
          inline_images: false,
          inline_stylesheet: true,
          mask_all_inputs: true,
          mask_input_options: {},
          mask_text_selector: '*',
          sampling_rate: 10,
        },
      },
      loader_config: {
        accountID: 1511127,
        agentID: 1834915278,
        applicationID: 1834915278,
        licenseKey: 'NRBR-33950553321f9090b38',
        trustKey: 1074045,
      },
    },
  },
};
